<template>
  <div class="edit-checkpoint-card">
    <div class="edit-left-check-card">
      <div class="mb-3 check-level-picker">
        <CheckpointLevelPicker
          label="Select Level"
          :levels="[
            { id: 1, name: 'Apprentice', value: 'apprentice' },
            { id: 2, name: 'Professional', value: 'professional' },
            { id: 3, name: 'Coach', value: 'coach' },
            { id: 4, name: 'Master', value: 'master' },
          ]"
          :value="readiness_level"
          @item-selected="resetLevel"
        />
      </div>
      <Button
        size="small"
        label="Edit"
        :normal="'normal-hover'"
        class="ins-btn"
        @onClick="handleEditClick"
      ></Button>
      <WatchVideoButton
        v-if="video_url"
        :label="'Watch Video'"
        class="ins-watch-video"
        @onClick="handleWatchVideo"
      />
    </div>
    <ExCriteriaInstructionsCell
      :prefix="formatCriteriaPrefix(prefix)"
      :criteria="criteria"
      :instructions="instructions"
      :videoThumbnail="videoThumbnail"
      :videoUrl="videoUrl"
      :rubric="rubric"
      class="ex-checkpoint-area"
    />
  </div>
</template>
  
<script setup>
  import Button from "@components/buttons/Button.vue";
  import WatchVideoButton from "@components/WatchVideoButton/WatchVideoButton.vue";
  import ExCriteriaInstructionsCell from "@components/InstructionsCell/ExCriteriaInstructionsCell.vue";
  import CheckpointLevelPicker from "@components/CheckpointLevelPicker/CheckpointLevelPicker.vue";
  import { formatCriteriaPrefix } from "@components/utils/formatCriteriaPrefix";
  
  // Props definition
  const props = defineProps({
    readiness_level: {
      type: Object,
      default: () => ({
        id: 1,
        name: "Apprentice",
        value: "apprentice",
      }),
    },
    criteria: {
      type: String,
      default: null
    },
    instructions: {
      type: String,
      default: null
    },
    video_url: {
      type: String,
      default: "1"
    },
    prefix: {
      type: String,
      default: ""
    },
    videoThumbnail: {
      type: String,
      default: null
    },
    videoUrl: {
      type: String,
      default: null
    },
    rubric: {
      type: Object,
      default: () => ({})
    }
  });
  
  // Emits
  const emit = defineEmits(['level-changed', 'watch-video', 'edit-click']);
  
  const resetLevel = (newLevel) => {
    emit('level-changed', newLevel);
  };
  
  const handleWatchVideo = () => {
    emit('watch-video', props.video_url);
  };

  const handleEditClick = () => {
    emit('edit-click');
  };
</script>
  
<style>
  .edit-checkpoint-card {
    display: flex;
    flex-direction: column;
    padding: 0px 8px 8px 8px;
    position: relative;
    overflow: visible;
  }
  .edit-checkpoint-card .edit-left-check-card {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .edit-checkpoint-card .ex-checkpoint-area {
    margin-top: -12px;
  }
  .edit-checkpoint-card .ex-right-bar {
    margin-top: 5px;
  }
  .edit-checkpoint-card .check-level-picker {
    margin-top: -10px;
  }
  .edit-checkpoint-card .check-level-picker .level-picker {
    margin: 0px 0px -6px -12px;
    position: relative;
  }
  .edit-checkpoint-card .ins-btn {
    width: 51px;
    height: 37px;
    position: relative !important;
    top: -15px;
  }
  .edit-checkpoint-card .ins-watch-video {
    margin: 5px;
    position: relative;
    top: -15px;
  }
  .edit-checkpoint-card .ins-watch-video .video-btn {
    height: 37px;
    font-size: 12px;
    padding: 15px;
    border: 1px solid #D0D5DD !important;
    box-shadow: 0px 1px 2px 0px #1018280D !important;
    gap: 8px;
  }
  .edit-checkpoint-card .ins-watch-video .video-btn:hover {
    background-color: #f5f3f3;
  }
  .edit-checkpoint-card .ins-watch-video:hover {
    box-shadow: none !important;
    background-color: transparent !important;
  }
  .edit-checkpoint-card .ins-watch-video .video-avatar-container {
    width: 20px;
    height: 20px;
  }
  .edit-checkpoint-card .ex-checkpoint-area .criteria-text {
    margin: 4px 0px 0px !important;
    white-space: nowrap;         /* keep it on one line */
    overflow: hidden;            /* hide overflow */
    text-overflow: ellipsis;     /* show "..." */
    width: 97%;                /* set a width (or use max-width) */
    display: inline-block;
  }
</style>

